import * as React from 'react';
function LogoXINGButterflyDuo(props) {
    return (React.createElement("svg", { viewBox: "0 0 28 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "LogoXINGButterflyDuo", ...props },
        React.createElement("g", { clipPath: "url(#prefix__clip0_47_1357)", fillRule: "evenodd", clipRule: "evenodd" },
            React.createElement("path", { d: "M1.81 5.986l3.655 6.479L0 22.021h6.515l5.429-9.556-3.656-6.479H1.81z", fill: "#0698A0" }),
            React.createElement("path", { d: "M21.207 0L10.67 18.644 17.464 31h6.614l-6.904-12.356L27.712 0h-6.505z", fill: "#B7DF4B" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "prefix__clip0_47_1357" },
                React.createElement("path", { fill: "#fff", d: "M0 0h28v31H0z" })))));
}
export default LogoXINGButterflyDuo;
//# sourceMappingURL=LogoXINGButterflyDuo.js.map